import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            filter: '',
            companies: [],
            programs: [],
            selectedPrograms: [0],
            isTemplateFilter: false,
            activePrograms: [
                {
                    id: 0,
                    name: LocService.t('label_pp_active')
                },
                {
                    id: 1,
                    name: LocService.t('label_pp_not_active')
                }
            ],
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            },
        }
    },
    methods: {
        load: load,
        editCompany: editCompany,
        getName: getName,
        formatDate: formatDate,
        addCompany: addCompany,
        previewProgram: previewProgram,
        editPersonalProgram: editPersonalProgram,
        copyPersonalProgram: copyPersonalProgram,
        programResults: programResults,
        viewPersonalProgram: viewPersonalProgram,
        deletePersonalProgram: deletePersonalProgram,
        clickSelectState: clickSelectState,
        addPersonalProgram: addPersonalProgram,
        isSelected: isSelected,
        getChipClass: getChipClass,
        allPersonalTrainings: allPersonalTrainings,
        keymonitor: keymonitor,
        toggleTemplateFilter: toggleTemplateFilter,

    },

    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load()
            }
        }
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.load()
    }
}


function load() {
    let _self = this;

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        type: "PERSONAL",
        active: _self.isTemplateFilter === true ? true : _self.selectedPrograms[0] === 0,
        isTemplate: _self.isTemplateFilter === true
    }

    AdminApiService.getPersonalPrograms(request)
        .then((response) => {
            _self.programs = response.data.results
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function deleteCompany(company){
    let _self = this;

    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da uklonite saradnika: " + company.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteCompanyPayments(company.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno obrisan saradnik. Svi korisnici su izmenjeni koji su pripadali ovom saradniku.', 'success')
                _self.load();
            })
            .catch(error => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });


}

function editCompany(company) {
    this.$router.push('/add-company-payment?id=' + company.id + '&name='+company.name)
}

function addCompany() {
    this.$router.push('/add-company-payment')
}

function allPersonalTrainings(){
    this.$router.push('/all-personal-trainings');

}

function getChipClass(item){
    if(this.selectedPrograms.includes(item.id)){
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item){
    return this.selectedPrograms.includes(item.id)
}

function clickSelectState(item){
    if(this.selectedPrograms.includes(item.id) && this.isTemplateFilter === false){
        return;
    }
    this.isTemplateFilter = false;
    this.selectedPrograms = [];
    this.selectedPrograms.push(item.id)
    this.load();
}

function toggleTemplateFilter(){
    if(this.isTemplateFilter === true){
        return;
    }
    this.isTemplateFilter = true;
    this.selectedPrograms = [];
    this.pagination.page = 1;
    this.load();
}

function addPersonalProgram(){
    this.$router.push('add-personal-program')

}

function editPersonalProgram(id){
    this.$router.push('add-personal-program?id='+id)
}

function copyPersonalProgram(id){
    const template = this.isTemplateFilter === true ? 'true' : 'false';
    this.$router.push('copy-personal-program?id=' + id + '&template=' + template)
}


function programResults(item){
    this.$router.push('personal-program-results?id='+item.id + '&name='+item.name + '&userId='+item.userId)
}

function previewProgram(id, userId){
    this.$router.push('personal-admin-program?id='+id+'&userId=' + userId)
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function deletePersonalProgram(item){
    let _self = this;
    swal({
        title: LocService.t("label_delete_personal_program"),
        text: LocService.t("label_delete_personal_program_are_you_sure") + ": " + this.getName(item),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_no"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {
        });
        AdminApiService.deletePersonalProgram(item.id)
            .then((response) => {
                swal(LocService.t("label_success"), LocService.t('label_delete_personal_program_successfully'), 'success')
                _self.load();
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })

    })
}

function viewPersonalProgram(item){
    window.open('http://localhost:3010/#/personal-list-program-new-user?showType=DAY&enableFuture=-2&hideTitle=true&programToken='+session.getAccessToken(), '_blank');
    // window.open('http://localhost:3010/#/personal-list-program-user?showType=DAY&enableFuture=-2&hideTitle=true&programToken='+session.getAccessToken(), '_blank');
}



// WEBPACK FOOTER //
// ./src/components/Personal/Personal.js